import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d77e0574"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "award_listing" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "w-100 mt-5" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", { class: "header-row" }, [
    /*#__PURE__*/ _createElementVNode("th", { style: { "width": "15%" } }, "Awarding Party"),
    /*#__PURE__*/ _createElementVNode("th", { style: { "width": "37%" } }, "Category"),
    /*#__PURE__*/ _createElementVNode("th", { style: { "width": "37%" } }, "Work"),
    /*#__PURE__*/ _createElementVNode("th", { style: { "width": "11%" } }, "Year")
], -1));
const _hoisted_5 = { class: "table-row" };
const _hoisted_6 = { class: "image" };
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    key: 0,
    class: "year__mobile"
};
const _hoisted_9 = { class: "category" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_11 = { class: "fw-bold" };
const _hoisted_12 = { class: "client" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "fw-bold" }, "Client:", -1));
const _hoisted_15 = ["href"];
const _hoisted_16 = { key: 1 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "fw-bold" }, "Project:", -1));
const _hoisted_18 = ["href"];
const _hoisted_19 = { class: "year" };
const _hoisted_20 = {
    key: 0,
    class: "year"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'award_listing',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("table", _hoisted_3, [
                        _hoisted_4,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.awards, (award) => {
                            return (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                _createElementVNode("td", _hoisted_6, [
                                    _createElementVNode("img", {
                                        src: award.award_body.logo,
                                        class: "img-fluid",
                                        style: { "max-width": "120px" },
                                        loading: "lazy"
                                    }, null, 8, _hoisted_7),
                                    (award.year)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(award.year), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_9, [
                                    _createTextVNode(_toDisplayString(award.category), 1),
                                    _hoisted_10,
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(award.result), 1)
                                ]),
                                _createElementVNode("td", _hoisted_12, [
                                    (award.client.alias !== null && award.client.title !== null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _hoisted_14,
                                            _createTextVNode(),
                                            _createElementVNode("a", {
                                                href: award.client.alias
                                            }, _toDisplayString(award.client.title), 9, _hoisted_15)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (award.project.alias !== null && award.project.title !== null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _hoisted_17,
                                            _createTextVNode(),
                                            _createElementVNode("a", {
                                                href: award.project.alias
                                            }, _toDisplayString(award.project.title), 9, _hoisted_18)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_19, [
                                    (award.year)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(award.year), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ]));
        };
    }
});
